var exports = {
  "lq": "Hero__Ycq-Zo",
  "uw": "Hero__primerHero__UgcRci",
  "cH": "Hero__ctas__dRgjKt",
  "QL": "Hero__ctas--mobile__ftdf5x",
  "Vx": "Hero__imageContainer__u7qhlI",
  "Ur": "Hero__imageDither__WvXj0S",
  "$3": "Hero__osBadges__61KRWu",
  "FX": "Hero__osBadges-item__-iGnqq",
  "uA": "Hero__gridFrame__V9L8QH",
  "cJ": "Hero__gridContent__43MoSG",
  "v2": "Hero__gridContentWide__YcYopG",
  "v1": "Hero__gridColumn__xG-f2e",
  "tM": "Hero__visualsContent__se14E9",
  "dX": "Hero__visualPanel__-rqkyR",
  "C_": "Hero__content__E5laui",
  "ze": "Hero__visual__5zTx63",
  "A6": "Hero__visual--image__sOPf0z",
  "qY": "Hero__ditherBg__D2lf4Z",
  "r_": "Hero__tabs__4GIWhu",
  "wM": "Hero__tabsWrapper__8zb0Ff",
  "GS": "Hero__playButtonWrapper__ZtrFV4",
  "QG": "Hero__playButtonWrapper--hidden__OO8HQV",
};

module.exports = exports;
